import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getInitData } from 'services/apiAuth1'

// 🔹 Cache key and function to read from localStorage
const CACHE_KEY = 'appInitData';

const getCachedData = () => {
    const cachedData = localStorage.getItem(CACHE_KEY);
    if (cachedData) {
        try {
            return JSON.parse(cachedData);
        } catch (error) {
            console.error("Failed to parse cached data, removing it.", error);
            localStorage.removeItem(CACHE_KEY);
        }
    }
    return undefined;
};

// 🔹 Export this so it can be used elsewhere
export const fetchInitDataFn = async () => {
    console.log("Fetching initial data from API.");
    const serverData = await getInitData();
    localStorage.setItem(CACHE_KEY, JSON.stringify(serverData));
    return serverData;
};

// 🔹 Main hook
const useIniDataFromDb = () => {
    return useQuery({
        queryKey: ['initData'],
        queryFn: fetchInitDataFn,
        initialData: getCachedData(),
        staleTime: 1000 * 60 * 60 * 4, // 4 hours
        gcTime: Infinity
    });
};

export default useIniDataFromDb;
